const MEC_ORIGIN = 'https://www.mec.ca';

const BRANCH_ORIGINS: Record<string, string> = {
  main: MEC_ORIGIN,
  develop: 'https://bc-test.mec.ca',
  uat: 'https://uat.mec.ca',
};

function getMenuOrigin(activeOrigin?: string): string {
  if (process.env.NODE_ENV === 'development') {
    return process.env.NEXT_PUBLIC_DEV_ORIGIN ?? 'http://localhost:3000';
  }

  const branch = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF;
  if (branch && Object.hasOwn(BRANCH_ORIGINS, branch)) {
    return BRANCH_ORIGINS[branch];
  }

  // For non-mapped branches (for example preview/commit ref URLs),
  // use the active runtime origin when available.
  if (activeOrigin) {
    return activeOrigin;
  }

  if (!branch) return MEC_ORIGIN;
  const vercelUrl = process.env.NEXT_PUBLIC_VERCEL_URL;
  return vercelUrl ? `https://${vercelUrl}` : MEC_ORIGIN;
}

// T must be JSON-serializable (no functions, undefined, or circular refs).
// Safe here because all callers pass data from JSON module imports.
export function transformMenuData<T>(data: T, activeOrigin?: string): T {
  const origin = getMenuOrigin(activeOrigin);
  if (origin === MEC_ORIGIN) return data;
  return JSON.parse(JSON.stringify(data).replaceAll(MEC_ORIGIN, origin));
}
